"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Types = _interopRequireDefault(require("../../types/Types"));

var _ChangeRequest = _interopRequireDefault(require("../../change/ChangeRequest"));

var _ActionCreators = _interopRequireDefault(require("../../change/ActionCreators"));

var _shouldDangerouslyUpdateParcelData = _interopRequireDefault(require("../../parcelData/shouldDangerouslyUpdateParcelData"));

var _ValidateValueUpdater = _interopRequireDefault(require("../../util/ValidateValueUpdater"));

var _default = function _default(_this) {
  return {
    dispatch: function dispatch(dispatchable) {
      (0, _Types.default)("dispatch()", "dispatchable", "dispatchable")(dispatchable);
      var _updateChangeRequestOnDispatch = _this._updateChangeRequestOnDispatch,
          _onHandleChange = _this._onHandleChange;
      var changeRequest = dispatchable instanceof _ChangeRequest.default ? dispatchable : new _ChangeRequest.default(dispatchable);

      if (!changeRequest._originId) {
        changeRequest._originId = _this.id;
        changeRequest._originPath = _this.path;
      }

      if (process.env.NODE_ENV !== 'production' && _this._log) {
        console.log("Parcel: \"".concat(_this._logName, "\" data up:")); // eslint-disable-line

        console.log(changeRequest.toJS()); // eslint-disable-line
      }

      if (_onHandleChange) {
        var changeRequestWithBase = changeRequest._create({
          prevData: _this.data
        });

        var parcelData = changeRequestWithBase.nextData;

        if (!parcelData) {
          return;
        }

        var parcelWithChangedData = _this._create({
          handleChange: _onHandleChange,
          parcelData: parcelData,
          lastOriginId: changeRequest.originId
        });

        _onHandleChange(parcelWithChangedData, changeRequestWithBase);

        return;
      }

      _this._dispatchToParent(_updateChangeRequestOnDispatch(changeRequest));
    },
    setSelf: function setSelf(value) {
      _this.dispatch(_ActionCreators.default.setSelf(value));
    },
    updateSelf: function updateSelf(updater) {
      (0, _Types.default)("updateSelf()", "updater", "function")(updater);

      if ((0, _shouldDangerouslyUpdateParcelData.default)(updater)) {
        var updated = updater(_this._parcelData);

        _this.dispatch(_ActionCreators.default.setData(updated));

        return;
      }

      var value = _this.value;
      var updatedValue = updater(value);
      (0, _ValidateValueUpdater.default)(value, updatedValue);

      _this.set(updatedValue);
    },
    onChange: _this.set,
    onChangeDOM: function onChangeDOM(event) {
      (0, _Types.default)("onChangeDOM()", "event", "event")(event);

      _this.onChange(event.currentTarget.value);
    },
    onChangeDOMCheckbox: function onChangeDOMCheckbox(event) {
      (0, _Types.default)("onChangeDOMCheckbox()", "event", "event")(event);

      _this.onChange(event.currentTarget.checked);
    },
    setMeta: function setMeta(partialMeta) {
      (0, _Types.default)("setMeta()", "partialMeta", "object")(partialMeta);

      _this.dispatch(_ActionCreators.default.setMeta(partialMeta));
    }
  };
};

exports.default = _default;